import { gql } from "@apollo/client";

export const VALIDAR_DISCREPANCIA_VISITA = gql`
    query validarDiscrepanciaHorariaVisita(
        $idVisita: Int!
        $fechaInicioUsuario: CustomDateTime!
        $fechaFinUsuario: CustomDateTime!
    ){
        validarDiscrepanciaHorariaVisita(
            idVisita: $idVisita 
            fechaInicioUsuario: $fechaInicioUsuario 
            fechaFinUsuario: $fechaFinUsuario 
        ){
            valorEsperado
            success
            error
        }
    }
`;